import {Shortcuts} from "./shortcut_types";
import {ShortcutEnum} from "./shortcut_enum";

export const getShortcuts = (enableFuture?: boolean, isDailyView?: boolean, isLabResults?: boolean, isMedications?: boolean) => {
    const shortcuts: Shortcuts = {
        dailyShortcuts: [
            {
                label: ShortcutEnum.TODAY,
                getValue: () => {
                    const today = new Date();
                    return {start: today, end: today};
                },
            },
            {
                label: ShortcutEnum.LAST_3_DAYS,
                getValue: () => {
                    const today = new Date();
                    const threeDaysAgo = new Date();
                    threeDaysAgo.setDate(today.getDate() - 2);
                    return {start: threeDaysAgo, end: today};
                },
                evaluateHidden: () => !isMedications,
            },
            {
               label: ShortcutEnum.LAST_5_DAYS,
                getValue: () => {
                    const today = new Date();
                    const fiveDaysAgo = new Date();
                    fiveDaysAgo.setDate(today.getDate() - 4);
                    return {start: fiveDaysAgo, end: today};
                },
                evaluateHidden: () => !isMedications,
            },
            {
                label: ShortcutEnum.LAST_7_DAYS,
                getValue: () => {
                    const today = new Date();
                    const sevenDaysAgo = new Date();
                    sevenDaysAgo.setDate(today.getDate() - 6);
                    return {start: sevenDaysAgo, end: today};
                },
            },
            {
                label: ShortcutEnum.LAST_31_DAYS,
                getValue: () => {
                    const today = new Date();
                    const thirtyOneDaysAgo = new Date();
                    thirtyOneDaysAgo.setDate(today.getDate() - 30);
                    return {start: thirtyOneDaysAgo, end: today};
                },
            },
            {
                label: ShortcutEnum.CURRENT_MONTH,
                getValue: () => {
                    const today = new Date();
                    const firstDayOfTheCurrentMonth = new Date(today.getFullYear(), today.getMonth(), 1);
                    const lastDayOfTheCurrentMonth = new Date(today.getFullYear(), today.getMonth() + 1, 0);
                    return {start: firstDayOfTheCurrentMonth, end: lastDayOfTheCurrentMonth};
                    // return {start: firstDayOfTheCurrentMonth, end: today};
                },
                evaluateHidden: () => isMedications,
            },
            {
                label: ShortcutEnum.PREVIOUS_MONTH,
                getValue: () => {
                    const today = new Date();
                    const firstDayOfThePreviousMonth = new Date(today.getFullYear(), today.getMonth() - 1, 1);
                    const lastDayOfThePreviousMonth = new Date(today.getFullYear(), today.getMonth(), 0);
                    return {start: firstDayOfThePreviousMonth, end: lastDayOfThePreviousMonth};
                },
                evaluateHidden: () => isMedications,
            },
          {
            label: ShortcutEnum.LAST_YEAR,
            getValue: () => {
              const today = new Date();
              const lastYear = new Date(today);
              lastYear.setFullYear(today.getFullYear() - 1);

              return {
                start: lastYear,
                end: today
              };
            },
            evaluateHidden: () => !isLabResults,
          }
        ],
        monthlyShortcuts: [
            {
                label: ShortcutEnum.CURRENT_MONTH,
                getValue: () => {
                    const today = new Date();
                    const firstDayOfTheCurrentMonth = new Date(today.getFullYear(), today.getMonth(), 1);
                    const lastDayOfTheCurrentMonth = new Date(today.getFullYear(), today.getMonth() + 1, 0);
                    return {start: firstDayOfTheCurrentMonth, end: lastDayOfTheCurrentMonth};
                },
            },
            {
                label: ShortcutEnum.PREVIOUS_MONTH,
                getValue: () => {
                    const today = new Date();
                    const firstDayOfThePreviousMonth = new Date(today.getFullYear(), today.getMonth() - 1, 1);
                    const lastDayOfThePreviousMonth = new Date(today.getFullYear(), today.getMonth(), 0);
                    return {start: firstDayOfThePreviousMonth, end: lastDayOfThePreviousMonth};
                },
            },
            {
                label: ShortcutEnum.CURRENT_YEAR,
                getValue: () => {
                    const today = new Date();
                    const firstDayOfTheYear = new Date(today.getFullYear(), 0, 1);
                    const lastDayOfTheYear = new Date(today.getFullYear(), 11, 31);
                    // const lastDayOfTheYear = new Date(today?.getFullYear(), today?.getMonth() + 1, 0)
                    return {start: firstDayOfTheYear, end: lastDayOfTheYear};
                },
            },
            {
                label: ShortcutEnum.PREVIOUS_YEAR,
                getValue: () => {
                    const today = new Date();
                    const lastYear = today.getFullYear() - 1;
                    const firstDayOfTheLastYear = new Date(lastYear, 0, 1);
                    const lastDayOfTheLastYear = new Date(lastYear, 11, 31);
                    return {start: firstDayOfTheLastYear, end: lastDayOfTheLastYear};
                },
            },
        ],
        commonShortcuts: [
            {
                label: ShortcutEnum.IN_THE_PAST,
                getValue: () => {
                    const today = new Date();
                    if (isDailyView) {
                      today.setDate(today.getDate() - 1);
                    } else {
                      today.setMonth(today.getMonth() - 1);
                      // today.setMonth(today.getMonth());
                      // today.setDate(0);
                    }
                    const firstDayInThePast = new Date(1900, 0, 1);
                    return {start: firstDayInThePast, end: today};
                },
              evaluateHidden: () => isMedications || isLabResults,
            },
            {
                label: ShortcutEnum.IN_THE_FUTURE,
                getValue: () => {
                    const today = new Date();
                    if (isDailyView) {
                      today.setDate(today.getDate() + 1);
                    } else {
                      today.setMonth(today.getMonth() + 1);
                    }
                    const lastDayInTheFuture = new Date(2099, 11, 31);
                    return {start: today, end: lastDayInTheFuture};
                },
                evaluateHidden: () => !enableFuture,
            },
        ],
    };
    return shortcuts;
}
